import React, { FC, ReactNode } from 'react';
import { TransitionGroup, Transition } from 'react-transition-group';
import type { TransitionStatus } from 'react-transition-group';
import { Route, Switch, useLocation } from 'react-router-dom';

export const animations = {
  timeout: 300,
  fade: {
    default: 'transition-opacity opacity-0',
    entering: '',
    entered: 'opacity-100 duration-200',
    exiting: 'opacity-0 duration-300',
    exited: 'opacity-0',
  },
};

interface DiffViewAnimationProps {
  nodeRef: React.RefObject<HTMLDivElement>;
  children: (state: TransitionStatus) => ReactNode;
}

const DiffViewAnimation: FC<DiffViewAnimationProps> = ({ children, nodeRef }) => {
  const location = useLocation();

  return (
    <TransitionGroup
      appear
      component={null}
    >
      <Transition
        key={location.pathname}
        in
        nodeRef={nodeRef}
        timeout={animations.timeout}
      >
        {(state) => children(state)}
      </Transition>
    </TransitionGroup>
  );
};

export default DiffViewAnimation;
